import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.entity.dictionary');
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-entity-dictionary',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.entity.dictionary/view.scss */
@charset "UTF-8";
.entity-page {
  color: #30372f;
  min-height: 100%;
  background: var(--ro-canvas, #fafbf8);
}

.entity-page *, .entity-page *::before, .entity-page *::after {
  box-sizing: border-box;
}

.e-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #d9dfd5;
  border-radius: 8px;
  background: #fff;
  padding: 10px 14px;
  min-height: 40px;
  color: #394035;
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  text-decoration: none;
  cursor: pointer;
}

.e-button:hover {
  background: #f2f5ec;
  border-color: #aab79a;
}

.e-button--primary {
  background: #3b4237;
  color: #fff;
  border-color: #3b4237;
}

.e-button--primary:hover {
  background: #525d45;
  color: #fff;
}

.e-button:disabled, .e-text-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.entity-page button:focus-visible, .entity-page a:focus-visible, .entity-page input:focus-visible, .entity-page select:focus-visible, .entity-page textarea:focus-visible {
  outline: 3px solid #ef603b;
  outline-offset: 3px;
}

.e-text-button {
  border: 0;
  background: transparent;
  color: #a2452c;
  padding: 8px;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.e-back {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  color: #697561;
  text-decoration: none;
  margin-bottom: 14px;
}

.e-item-link {
  color: #30372f;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
}

.e-item-link:hover {
  color: #b34429;
  text-decoration: underline;
}

.e-notice, .e-error {
  padding: 14px 18px;
  border-radius: 9px;
  margin: 0 0 18px;
  line-height: 1.7;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.e-notice {
  color: #775c25;
  border: 1px solid #ecdfbd;
  background: #fffaf0;
}

.e-error {
  color: #9c3529;
  border: 1px solid #edc9c2;
  background: #fff5f2;
}

.e-error p, .e-notice p {
  margin: 4px 0;
}

.e-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}

.e-metrics article {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 24px;
  background: #fff;
  border: 1px solid #e1e5dc;
  border-radius: 12px;
}

.e-metrics span {
  font-size: 12px;
  color: #74806b;
}

.e-metrics strong {
  font-size: 27px;
  letter-spacing: -0.5px;
}

.e-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 6px;
  padding: 5px 8px;
  background: #edf3e6;
  color: #596c40;
  font-size: 12px;
  font-weight: 650;
  white-space: normal;
}

.e-badge--muted {
  background: #f1f1eb;
  color: #777d70;
}

.e-tag-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.e-tag-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #d8dee8;
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 650;
  color: #596273;
  background: #f3f5f8;
  white-space: nowrap;
}

.e-tag-badge[data-tag-state=present] {
  color: #1d4f91;
  background: #edf4ff;
  border-color: #c9dcf6;
}

.e-tag-badge[data-tag-state=absent] {
  color: #875418;
  background: #fff6e7;
  border-color: #edd6b3;
}

.e-tag-badge[data-tag-state=mixed] {
  color: #654499;
  background: #f4effc;
  border-color: #ded0ef;
}

.e-subtext {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #7d8777;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.e-muted {
  font-size: 12px;
  color: #7a8473;
  line-height: 1.75;
  margin: 12px 0;
  overflow-wrap: anywhere;
}

.e-empty {
  padding: 34px 20px;
  text-align: center;
  color: #7b8573;
  font-size: 13px;
  line-height: 1.8;
}

.e-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  border-top: 1px solid #e7eae3;
  font-size: 12px;
  color: #79836f;
}

.e-pagination > div {
  display: flex;
  align-items: center;
  gap: 14px;
}

.e-project-table {
  min-width: 650px;
}

.e-project-table th, .e-project-table td {
  display: table-cell !important;
}

.e-project-table th:nth-child(1) {
  width: 36% !important;
}

.e-project-table th:nth-child(2) {
  width: 12% !important;
}

.e-project-table th:nth-child(3) {
  width: 20% !important;
}

.e-project-table th:nth-child(4) {
  width: 19% !important;
}

.e-project-table th:nth-child(5) {
  width: 13% !important;
}

.e-list-cards {
  display: none;
}

.e-list-card {
  padding: 18px;
  border-bottom: 1px solid #e7ebdf;
}

.e-list-card__status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  font-size: 12px;
}

.e-list-card > .e-button {
  margin-top: 12px;
  width: 100%;
}

.e-card {
  min-width: 0;
  border: 1px solid #e1e5dc;
  border-radius: 12px;
  background: #fff;
  padding: 24px;
  margin-bottom: 22px;
}

.e-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.e-card h2 {
  font-size: 18px;
  margin: 0;
  font-weight: 750;
}

.e-card h3 {
  font-size: 16px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.e-card h4 {
  font-size: 13px;
  font-weight: 700;
  margin: 12px 0;
}

.e-eyebrow {
  font-size: 12px;
  letter-spacing: 1.4px;
  color: #db5b36;
  display: block;
  margin-bottom: 8px;
}

.e-description {
  font-size: 13px;
  line-height: 1.8;
  color: #66715e;
  margin-bottom: 14px;
}

.e-source-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.e-source-list article {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9f5;
  border-radius: 8px;
  font-size: 12px;
}

.e-source-list article > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.e-source-list .e-badge {
  flex-shrink: 0;
}

.e-two-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  align-items: start;
  gap: 22px;
}

.e-tree {
  max-height: 540px;
  overflow: auto;
  margin: 12px -10px 0;
}

.e-tree-row {
  display: flex;
  align-items: flex-start;
  border-radius: 6px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f2ec;
}

.e-tree-row.is-selected {
  background: #fff1e9;
}

.e-tree-toggle {
  flex: 0 0 26px;
  width: 26px;
  height: 32px;
  border: 0;
  background: none;
  font-size: 12px;
  color: #78846c;
  cursor: pointer;
}

.e-tree-toggle:disabled {
  opacity: 0.35;
  cursor: default;
}

.e-tree-title {
  text-align: left;
  border: 0;
  background: none;
  padding: 5px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  color: #394232;
}

.e-tree-title strong {
  font-size: 12px;
  line-height: 1.7;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.e-tree-title small {
  display: block;
  font-size: 12px;
  color: #87917d;
  line-height: 1.7;
  margin-top: 4px;
}

.e-search {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #dce2d6;
  padding: 10px 12px;
  border-radius: 8px;
  color: #839077;
}

.e-search input {
  min-width: 0;
  width: 100%;
  border: 0;
  outline: none;
  background: none;
  font-size: 12px;
}

.e-analysis {
  margin: 20px 0;
}

.e-analysis > div {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #edf0e7;
  padding: 12px 0;
  font-size: 13px;
}

.e-analysis dt {
  color: #7b8671;
}

.e-type-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 9px 0 18px;
}

.e-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 14px 0;
  font-size: 12px;
  color: #6a765e;
}

.e-field input, .e-field select, .e-field textarea, .e-filters input, .e-filters select {
  width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #dce2d6;
  border-radius: 7px;
  background: #fff;
  color: #3d4636;
  font: inherit;
  font-size: 12px;
}

.e-field textarea {
  resize: vertical;
}

.e-reviewer-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.e-reviewer-grid > label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e5e9df;
  border-radius: 8px;
  cursor: pointer;
}

.e-reviewer-grid input {
  accent-color: #778c35;
  margin-top: 4px;
}

.e-reviewer-grid strong {
  font-size: 13px;
}

.e-reviewer-grid small {
  display: block;
  color: #8c9582;
  font-size: 12px;
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.e-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.e-job {
  margin-top: 18px;
  border-radius: 8px;
  background: #f4f7ee;
  padding: 14px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.e-job progress {
  width: 100%;
  accent-color: #8ca13c;
}

.e-history {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #eef0e9;
  font-size: 12px;
}

.e-history > span {
  color: #859078;
}

.e-result-main {
  max-width: 2100px;
  padding: 22px;
  margin: 0 auto;
}

.e-workbench {
  display: grid;
  grid-template-columns: minmax(230px, 0.75fr) minmax(320px, 1.45fr) minmax(300px, 1fr);
  align-items: start;
  gap: 16px;
}

.e-workbench .e-card {
  padding: 18px;
}

.e-workbench .e-tree {
  max-height: 74vh;
}

.e-source-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 28px;
  font-size: 16px;
  max-height: 64vh;
  overflow-y: auto;
  padding: 18px 4px;
  color: #3d4537;
}

.e-source-text .is-entity {
  background: #f8eccb;
  border-radius: 3px;
  cursor: pointer;
}

.e-source-text .is-active {
  background: #ffc9a9;
  outline: 1px solid #df6a36;
}

.e-breadcrumbs {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.e-breadcrumbs button {
  border: 0;
  background: none;
  font-size: 12px;
  color: #858f7b;
  cursor: pointer;
  text-align: left;
}

.e-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0;
}

.e-filters > input {
  grid-column: 1/-1;
}

.e-occurrences {
  max-height: 34vh;
  overflow: auto;
}

.e-occurrence {
  width: 100%;
  border: 1px solid #e7ebdf;
  background: #fff;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  color: #3e4835;
}

.e-occurrence.is-active {
  border-color: #e77d4e;
  background: #fff6ef;
}

.e-occurrence__heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
}

.e-occurrence > small {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.8;
  color: #7d8971;
  overflow-wrap: anywhere;
}

.e-occurrence strong {
  overflow-wrap: anywhere;
}

.e-editor, .e-complete, .e-manual, .e-attachments {
  border-top: 1px solid #e8ecdf;
  margin-top: 20px;
  padding-top: 14px;
}

.e-attachments article {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
  font-size: 12px;
  overflow-wrap: anywhere;
}

@media (max-width: 1250px) {
  .e-workbench {
    grid-template-columns: 230px minmax(0, 1fr);
  }
  .e-occurrence-panel {
    grid-column: 1/-1;
  }
  .e-occurrences {
    max-height: 400px;
  }
  .e-reviewer-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .e-metrics {
    gap: 8px;
  }
  .e-metrics article {
    padding: 14px 10px;
  }
  .e-metrics strong {
    font-size: 22px;
  }
  .e-metrics span {
    font-size: 12px;
  }
  .e-two-panel, .e-workbench, .e-source-list {
    grid-template-columns: 1fr;
  }
  .e-card {
    padding: 18px;
  }
  .e-workbench .e-tree {
    max-height: 300px;
  }
  .e-workbench .e-occurrence-panel {
    grid-column: auto;
  }
  .e-result-main {
    padding: 14px;
  }
  .e-reviewer-grid {
    grid-template-columns: 1fr;
  }
  .e-pagination {
    padding: 14px;
  }
  .e-pagination > div {
    gap: 8px;
  }
}
@media (max-width: 1050px) {
  .entity-page .project-ledger__table-wrap {
    display: none;
  }
  .e-list-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .e-list-cards {
    grid-template-columns: 1fr;
  }
}
:host {
  display: block;
  height: 100%;
  min-height: 0;
  overflow: hidden !important;
}

.dictionary-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dictionary-page .creation-heading {
  min-width: 0;
}
.dictionary-page .creation-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
}
.dictionary-page .dictionary-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 0;
  font-size: 12px;
  line-height: 20px;
  color: var(--ro-muted);
  font-variant-numeric: tabular-nums;
}
.dictionary-page .dictionary-stats strong {
  font-size: inherit;
  font-weight: 700;
  color: var(--ro-ink);
}
.dictionary-page .e-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.dictionary-page .e-button {
  min-height: 44px;
  white-space: nowrap;
  font-size: 13px;
}
.dictionary-page .dictionary-header-actions {
  flex: 0 0 auto;
  flex-wrap: wrap;
  margin: 0;
}
.dictionary-page .dictionary-tools {
  position: relative;
}
.dictionary-page .dictionary-tools summary {
  cursor: pointer;
  list-style: none;
}
.dictionary-page .dictionary-tools summary::-webkit-details-marker {
  display: none;
}
.dictionary-page .dictionary-tools summary::after {
  content: "⌄";
  margin-left: 6px;
}
.dictionary-page .dictionary-tools__menu {
  position: absolute;
  z-index: 50;
  right: 0;
  top: calc(100% + 6px);
  min-width: 220px;
  display: grid;
  gap: 8px;
  background: white;
  border: 1px solid #dce2d8;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 8px 24px rgba(38, 54, 42, 0.1215686275);
}
.dictionary-page .ro-field {
  display: grid;
  gap: 5px;
  min-width: 0;
  color: #46533f;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}
.dictionary-page input, .dictionary-page select, .dictionary-page textarea {
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 9px 10px;
  border: 1px solid #bfcbb9;
  border-radius: 7px;
  background: #fff;
  color: #27362a;
  font: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}
.dictionary-page textarea {
  resize: vertical;
}
.dictionary-page input:disabled, .dictionary-page select:disabled, .dictionary-page textarea:disabled {
  background: #f3f5f1;
}
.dictionary-page input:focus-visible, .dictionary-page select:focus-visible, .dictionary-page textarea:focus-visible, .dictionary-page button:focus-visible, .dictionary-page a:focus-visible, .dictionary-page summary:focus-visible, .dictionary-page [tabindex]:focus-visible {
  outline: 3px solid #b94f2d;
  outline-offset: 2px;
}
.dictionary-page .dictionary-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.dictionary-page .dictionary-searchbar {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: minmax(120px, 1fr) 140px 110px 110px auto;
  align-items: end;
  gap: 12px;
  padding: 16px;
  border: 1px solid var(--ro-line);
  border-radius: 12px;
  background: var(--ro-surface);
}
.dictionary-page .dictionary-searchbar__query input {
  border-color: #829572;
}
.dictionary-page .dictionary-searchbar__reset {
  padding: 9px 12px;
}
.dictionary-page .dictionary-context {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 16px;
  font-size: 12px;
  color: #64705e;
}
.dictionary-page .dictionary-sync {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  font-size: 12px;
  line-height: 20px;
}
.dictionary-page .dictionary-sync strong {
  font-weight: 500;
}
.dictionary-page .dictionary-sync .e-text-button {
  padding: 3px 6px;
  min-height: 28px;
}
.dictionary-page .dictionary-sync progress {
  width: 140px;
  accent-color: #55724d;
}
.dictionary-page .dictionary-sync.is-important {
  flex: 1 1 100%;
  color: #775c25;
  padding: 8px 12px;
  border: 1px solid #ecdfbd;
  border-radius: 7px;
  background: #fffaf0;
}
.dictionary-page .dictionary-message, .dictionary-page .dictionary-global-error {
  flex: 0 0 auto;
  margin: 0;
  padding: 8px 12px;
}
.dictionary-page .dictionary-workspace {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(500px, 0.95fr) minmax(0, 1.05fr);
  gap: 12px;
  align-items: stretch;
}
.dictionary-page .dictionary-list, .dictionary-page .dictionary-detail {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border: 1px solid var(--ro-line);
  border-radius: 12px;
  background: var(--ro-surface);
}
.dictionary-page h2, .dictionary-page h3 {
  margin: 0;
  padding: 0;
  border: 0;
  color: var(--ro-ink);
}
.dictionary-page h2 {
  font-size: 18px;
  line-height: 26px;
}
.dictionary-page h3 {
  font-size: 15px;
  line-height: 24px;
}
.dictionary-page .dictionary-list__header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 12px;
  padding: 12px 14px;
}
.dictionary-page .dictionary-list__header > div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.dictionary-page .dictionary-list__header h2 {
  font-size: 15px;
  line-height: 24px;
}
.dictionary-page #dictionary-result-count {
  font-size: 13px;
  font-weight: 600;
  color: #65745a;
}
.dictionary-page .dictionary-range {
  margin: 0;
  font-size: 12px;
  line-height: 20px;
  color: #64705e;
  font-variant-numeric: tabular-nums;
}
.dictionary-page .dictionary-column-head, .dictionary-page .dictionary-row {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) 56px 56px 52px 64px;
  gap: 8px;
  align-items: center;
  padding: 10px 16px;
}
.dictionary-page .dictionary-column-head {
  flex: 0 0 auto;
  padding-top: 8px;
  padding-bottom: 8px;
  overflow-y: hidden;
  scrollbar-gutter: stable;
  background: #f5f7f2;
  border-block: 1px solid #e3e8de;
  color: #64705e;
  font-size: 12px;
  font-weight: 600;
}
.dictionary-page .dictionary-rows {
  flex: 1;
  min-height: 0;
  max-height: none;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}
.dictionary-page .dictionary-row {
  width: 100%;
  min-height: 64px;
  border: 0;
  border-radius: 0 !important;
  background: white;
  color: var(--ro-ink);
  text-align: left;
  cursor: pointer;
  box-shadow: none;
}
.dictionary-page .dictionary-rows > [role=listitem] + [role=listitem] {
  border-top: 1px solid var(--ro-line);
}
.dictionary-page .dictionary-row:hover {
  background: #f7f9f3;
}
.dictionary-page .dictionary-row.is-selected {
  background: #fff3eb;
}
.dictionary-page .dictionary-row__name {
  min-width: 0;
}
.dictionary-page .dictionary-row__name strong {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 21px;
  font-weight: 650;
}
.dictionary-page .dictionary-row__name small {
  display: block;
  margin-top: 3px;
  color: #64705e;
  font-size: 12px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dictionary-page .dictionary-selected-marker {
  color: #9e3d24;
  font-weight: 700;
}
.dictionary-page .dictionary-row > .e-badge {
  justify-self: start;
  font-size: 12px;
  padding: 4px 6px;
  max-width: 100%;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-state {
  display: inline-flex;
  justify-self: start;
  width: max-content;
  max-width: 100%;
  border-radius: 999px;
  padding: 3px 7px;
  font-size: 12px;
  line-height: 18px;
  background: #f0f2ed;
  color: #606b58;
}
.dictionary-page .dictionary-state[data-state=editing] {
  background: #fff4df;
  color: #805317;
}
.dictionary-page .dictionary-state[data-state=confirmed] {
  background: #e7f2e9;
  color: #316245;
}
.dictionary-page .dictionary-state[data-state=archived] {
  background: #edeef1;
  color: #666a73;
}
.dictionary-page .dictionary-count {
  text-align: right;
  font-size: 13px;
  line-height: 20px;
  font-variant-numeric: tabular-nums;
}
.dictionary-page .dictionary-count__label {
  display: none;
}
.dictionary-page .dictionary-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid #e3e8de;
  font-size: 12px;
}
.dictionary-page .dictionary-list-pagination {
  flex: 0 0 auto;
}
.dictionary-page .dictionary-page-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.dictionary-page .dictionary-page-actions .e-button {
  min-width: 36px;
  min-height: 40px;
  padding: 7px 8px;
}
.dictionary-page .dictionary-page-actions > span {
  padding: 0 4px;
  text-align: center;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.dictionary-page .dictionary-page-jump {
  display: flex;
  align-items: center;
  gap: 4px;
}
.dictionary-page .dictionary-page-jump input {
  width: 96px;
  min-height: 40px;
  padding: 7px;
  font-size: 13px;
}
.dictionary-page .dictionary-page-jump .e-button {
  min-height: 40px;
  padding: 7px 9px;
}
.dictionary-page .dictionary-list-pagination .e-error {
  flex-basis: 100%;
  margin: 0;
  padding: 6px 8px;
}
.dictionary-page .dictionary-detail__header {
  flex: 0 0 auto;
  padding: 16px 18px 12px;
  margin: 0;
}
.dictionary-page .dictionary-detail__identity {
  min-width: 0;
}
.dictionary-page .dictionary-detail__header h2 {
  font-size: 22px;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
}
.dictionary-page #dictionary-detail-title {
  width: fit-content;
  max-width: 100%;
  outline: none !important;
}
.dictionary-page .dictionary-detail__summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  color: #64705e;
  font-size: 13px;
  line-height: 20px;
  margin-top: 6px;
}
.dictionary-page .dictionary-detail__summary .e-badge {
  padding: 3px 7px;
}
.dictionary-page .dictionary-mobile-back {
  display: none;
}
.dictionary-page .dictionary-tabs {
  flex: 0 0 auto;
  display: flex;
  margin: 0 16px;
  padding: 4px;
  border: 1px solid var(--ro-line);
  border-radius: 10px;
  background: var(--ro-canvas);
  gap: 4px;
}
.dictionary-page .dictionary-tabs button {
  flex: 1;
  min-width: 0;
  min-height: 44px;
  padding: 10px 6px;
  border: 0;
  background: transparent;
  color: var(--ro-muted);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.dictionary-page .dictionary-tabs button[aria-selected=true] {
  color: #9e3d24;
  background: #fff0e9;
}
.dictionary-page .dictionary-tabs button span {
  font-size: 12px;
  font-weight: 500;
  margin-left: 3px;
}
.dictionary-page .dictionary-detail-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding: 16px 18px;
}
.dictionary-page .dictionary-tab-panel[hidden] {
  display: none !important;
}
.dictionary-page .dictionary-edit {
  display: grid;
  gap: 12px;
}
.dictionary-page .dictionary-edit__row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
.dictionary-page .dictionary-origin {
  display: grid;
  gap: 5px;
  font-size: 13px;
  line-height: 20px;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-origin small {
  color: #64705e;
  font-size: 12px;
}
.dictionary-page .dictionary-reference-fold {
  margin-top: 16px;
  border-top: 1px solid #e3e8de;
  padding-top: 12px;
}
.dictionary-page .dictionary-reference-fold > summary {
  min-height: 40px;
  line-height: 24px;
  padding-block: 8px;
  font-size: 14px;
  color: #46533f;
  font-weight: 600;
  cursor: pointer;
}
.dictionary-page .dictionary-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}
.dictionary-page .dictionary-references, .dictionary-page .dictionary-sources, .dictionary-page .dictionary-operations {
  margin: 0;
  padding: 0;
  border: 0;
}
.dictionary-page .dictionary-reference {
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e1e6dc;
  border-radius: 8px;
  margin: 10px 0;
  background: #fafbf8;
}
.dictionary-page .dictionary-reference .e-text-button {
  justify-self: start;
}
.dictionary-page .dictionary-save {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 12px 16px;
  border-top: 1px solid #dce2d8;
  background: #fafbf8;
}
.dictionary-page .dictionary-save > span {
  min-width: 0;
  font-size: 13px;
  line-height: 18px;
  color: #64705e;
}
.dictionary-page .dictionary-save .e-button {
  padding-inline: 12px;
}
.dictionary-page .dictionary-source {
  padding: 14px;
  border: 1px solid #dfe5d9;
  border-radius: 8px;
  margin-top: 12px;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-source.is-excluded {
  background: #f5f6f3;
  border-style: dashed;
}
.dictionary-page .dictionary-source__heading {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
}
.dictionary-page .dictionary-source strong {
  font-size: 14px;
  line-height: 22px;
}
.dictionary-page .dictionary-source small {
  display: block;
  font-size: 12px;
  line-height: 19px;
  color: #64705e;
  margin-top: 5px;
}
.dictionary-page .dictionary-source-selection {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px;
  margin-bottom: 14px;
  background: #fff7ed;
  font-size: 13px;
  border: 1px solid #ead8bd;
  border-radius: 7px;
}
.dictionary-page .dictionary-sources .dictionary-sources__header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  margin: 0 0 14px;
}
.dictionary-page .dictionary-sources .dictionary-sources__heading {
  min-width: 0;
}
.dictionary-page .dictionary-sources .dictionary-sources__heading p {
  margin: 3px 0 0;
  color: var(--ro-muted);
  font-size: 13px;
  line-height: 20px;
}
.dictionary-page .dictionary-sources #dictionary-sources-title {
  width: fit-content;
  outline: none !important;
}
.dictionary-page .dictionary-sources .dictionary-sources__tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.dictionary-page .dictionary-sources .dictionary-source-pager {
  display: flex;
  align-items: center;
  gap: 4px;
}
.dictionary-page .dictionary-sources .dictionary-source-pager .e-button {
  min-width: 44px;
  padding: 10px;
}
.dictionary-page .dictionary-sources .dictionary-source-pager > span {
  min-width: 48px;
  padding: 0 3px;
  text-align: center;
  font-size: 13px;
  color: var(--ro-muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.dictionary-page .dictionary-sources .dictionary-source-bulk {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
  padding: 8px;
  background: var(--ro-canvas);
  border-radius: 8px;
}
.dictionary-page .dictionary-sources .dictionary-source {
  margin: 12px 0 0;
  padding: 16px;
  border: 1px solid var(--ro-line);
  border-radius: 10px;
  background: var(--ro-surface);
}
.dictionary-page .dictionary-sources .dictionary-source.is-selected {
  border-color: var(--ro-accent);
  background: #fff9f4;
}
.dictionary-page .dictionary-sources .dictionary-source.is-excluded {
  background: var(--ro-canvas);
}
.dictionary-page .dictionary-sources .dictionary-source-check {
  min-height: 44px;
  margin-bottom: 8px;
  font-weight: 600;
}
.dictionary-page .dictionary-sources .dictionary-source__heading {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px 12px;
  align-items: start;
}
.dictionary-page .dictionary-sources .dictionary-source__heading > strong {
  flex: 1 1 140px;
  min-width: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 16px;
  line-height: 24px;
  font-weight: 650;
  color: var(--ro-ink);
}
.dictionary-page .dictionary-sources .dictionary-source__badges {
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.dictionary-page .dictionary-sources .dictionary-source__badges .e-badge {
  padding: 2px 7px;
}
.dictionary-page .dictionary-sources .dictionary-source__location {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: baseline;
  gap: 4px 12px;
  margin: 8px 0 12px;
  color: var(--ro-muted);
  font-size: 12px;
  line-height: 18px;
}
.dictionary-page .dictionary-sources .dictionary-source__location > span:first-child {
  min-width: 0;
  flex: 1 1 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dictionary-page .dictionary-sources .dictionary-source__position {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
}
.dictionary-page .dictionary-sources .dictionary-source-context {
  padding: 12px 14px 4px;
  background: var(--ro-canvas);
  border-radius: 8px;
}
.dictionary-page .dictionary-sources .dictionary-source-context > summary {
  list-style: none;
  cursor: pointer;
}
.dictionary-page .dictionary-sources .dictionary-source-context > summary::-webkit-details-marker {
  display: none;
}
.dictionary-page .dictionary-sources .dictionary-source-context__excerpt {
  display: block;
  color: var(--ro-ink);
  font-size: 15px;
  line-height: 26px;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-sources .dictionary-source-context mark, .dictionary-page .dictionary-sources .dictionary-evidence mark {
  padding: 1px 3px;
  border-radius: 3px;
  background: #ffe8d7;
  color: #8f351d;
  font-weight: 650;
}
.dictionary-page .dictionary-sources .dictionary-source-context mark {
  display: inline-block;
  max-width: 100%;
  vertical-align: baseline;
}
.dictionary-page .dictionary-sources .dictionary-source-context__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  gap: 12px;
  color: var(--ro-muted);
  font-size: 12px;
  line-height: 20px;
}
.dictionary-page .dictionary-sources .dictionary-source-context__opened {
  display: none;
}
.dictionary-page .dictionary-sources .dictionary-source-context[open] > summary .dictionary-source-context__excerpt, .dictionary-page .dictionary-sources .dictionary-source-context[open] .dictionary-source-context__closed {
  display: none;
}
.dictionary-page .dictionary-sources .dictionary-source-context[open] .dictionary-source-context__opened {
  display: inline;
}
.dictionary-page .dictionary-sources .dictionary-source-context[open] .dictionary-source-context__toggle > span:last-child {
  transform: rotate(180deg);
}
.dictionary-page .dictionary-sources .dictionary-source-context blockquote {
  margin: 0 0 10px;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 15px;
  line-height: 27px;
  white-space: pre-wrap;
}
.dictionary-page .dictionary-sources .dictionary-source-main-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 4px;
  margin-top: 4px;
}
.dictionary-page .dictionary-sources .dictionary-source-main-actions .e-text-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 6px;
  text-decoration: none;
}
.dictionary-page .dictionary-sources .dictionary-source-info-toggle {
  margin-left: auto;
}
.dictionary-page .dictionary-sources .dictionary-source-info {
  border-top: 1px solid var(--ro-line);
  margin-top: 4px;
}
.dictionary-page .dictionary-sources .dictionary-source-info[hidden] {
  display: none !important;
}
.dictionary-page .dictionary-sources .dictionary-source-info dl {
  display: grid;
  gap: 12px;
  margin: 4px 0 16px;
  font-size: 13px;
  line-height: 22px;
}
.dictionary-page .dictionary-sources .dictionary-source-info dl > div {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 12px;
}
.dictionary-page .dictionary-sources .dictionary-source-info dt {
  color: var(--ro-muted);
  font-weight: 500;
}
.dictionary-page .dictionary-sources .dictionary-source-info dd {
  min-width: 0;
  margin: 0;
  color: var(--ro-ink);
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-sources .dictionary-source-note {
  white-space: pre-wrap;
}
.dictionary-page .dictionary-sources .dictionary-source-link-actions {
  border-top: 1px solid var(--ro-line);
  padding-top: 8px;
}
.dictionary-page .dictionary-sources .dictionary-source-link-actions p {
  margin: 4px 0 8px;
  color: var(--ro-muted);
  font-size: 12px;
  line-height: 20px;
}
.dictionary-page .dictionary-sources .dictionary-source-warning {
  margin: 10px 0;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff4df;
  color: #805317;
  font-size: 13px;
  line-height: 22px;
}
.dictionary-page .dictionary-sources .dictionary-evidence {
  margin: 0 0 10px;
  border-color: #c8ddcd;
  background: #f3f9f4;
}
.dictionary-page .dictionary-sources .dictionary-evidence > strong {
  color: #316245;
}
.dictionary-page blockquote {
  margin: 10px 0;
  padding: 9px 11px;
  border-left: 3px solid #a8b89c;
  background: #f6f8f2;
  font-size: 14px;
  line-height: 1.8;
}
.dictionary-page .dictionary-evidence {
  margin-top: 12px;
  padding: 12px;
  background: #faf7ee;
  border: 1px solid #e6ddbe;
  border-radius: 7px;
}
.dictionary-page .dictionary-evidence p {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 14px;
  line-height: 1.8;
  margin: 8px 0 0;
}
.dictionary-page mark {
  background: #ffe29c;
  color: #382c0e;
}
.dictionary-page .dictionary-placeholder {
  margin: auto;
  padding: 40px 24px;
  line-height: 1.8;
}
.dictionary-page .dictionary-placeholder i {
  font-size: 30px;
  color: #7b8d70;
  margin-bottom: 16px;
}
.dictionary-page .e-empty {
  color: #64705e;
}
.dictionary-page .e-muted {
  color: #64705e;
  font-size: 13px;
  line-height: 1.7;
}
.dictionary-page .dictionary-history {
  border-top: 1px solid #e3e8de;
  margin-top: 20px;
  padding-top: 12px;
}
.dictionary-page .dictionary-history summary {
  min-height: 40px;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
}
.dictionary-page .dictionary-history p {
  font-size: 12px;
  line-height: 19px;
  color: #64705e;
}
.dictionary-page #dictionary-detail-error {
  margin: 16px;
}
.dictionary-page .dictionary-operations {
  border-top: 1px solid #e3e8de;
  margin-top: 24px;
  padding-top: 20px;
}
.dictionary-page .dictionary-operation {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #c9d6c1;
  border-radius: 9px;
  background: #f8faf5;
  display: grid;
  gap: 16px;
}
.dictionary-page .dictionary-operation .dictionary-section-heading {
  margin-bottom: 0;
}
.dictionary-page .dictionary-operation-fields, .dictionary-page .dictionary-candidate-picker {
  display: grid;
  gap: 12px;
}
.dictionary-page .dictionary-candidates {
  display: grid;
  gap: 8px;
  max-height: 360px;
  overflow: auto;
}
.dictionary-page .dictionary-candidate {
  display: grid;
  gap: 5px;
  width: 100%;
  border: 1px solid #cbd4c5;
  border-radius: 7px;
  padding: 12px;
  background: white;
  color: #33412e;
  text-align: left;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.dictionary-page .dictionary-candidate span, .dictionary-page .dictionary-candidate small {
  font-size: 12px;
}
.dictionary-page .dictionary-candidate.is-selected {
  border: 2px solid #55724d;
  background: #eef5e7;
  padding: 11px;
}
.dictionary-page .dictionary-chosen {
  display: grid;
  gap: 8px;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-operation-preview {
  border: 1px solid #d9d0b4;
  border-radius: 8px;
  padding: 16px;
  background: #fffdf6;
  display: grid;
  gap: 12px;
}
.dictionary-page .dictionary-operation-preview h4 {
  margin: 0;
  font-size: 15px;
}
.dictionary-page .dictionary-operation-preview p {
  margin: 0;
  font-size: 13px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-preserved-description {
  white-space: pre-wrap;
  max-height: 220px;
  overflow: auto;
}
.dictionary-page .dictionary-check {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  font-size: 13px;
  color: #46533f;
  cursor: pointer;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-check input {
  width: 20px;
  height: 20px;
  min-height: 20px;
  flex: 0 0 20px;
  accent-color: #55724d;
}
.dictionary-page .dictionary-history-item {
  padding: 12px 0;
  border-bottom: 1px solid #e3e8de;
}
.dictionary-page .dictionary-history-item .e-text-button {
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-suggestions {
  border: 1px solid #dce2d8;
  border-radius: 12px;
  padding: 24px;
  background: #fff;
  min-width: 0;
}
.dictionary-page .dictionary-suggestions__header {
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.dictionary-page .dictionary-suggestions__header > div:first-child {
  flex: 1 1 320px;
}
.dictionary-page .dictionary-suggestion-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  gap: 12px;
  margin-top: 20px;
}
.dictionary-page .dictionary-suggestion-filters .ro-field:first-child {
  flex: 1 1 280px;
}
.dictionary-page .dictionary-suggestion-filters .ro-field {
  flex: 0 1 200px;
}
.dictionary-page .dictionary-suggestion-row {
  padding: 20px;
  border: 1px solid #dce2d8;
  border-radius: 9px;
  margin-top: 12px;
  display: grid;
  gap: 14px;
}
.dictionary-page .dictionary-suggestion-row > button {
  justify-self: end;
}
.dictionary-page .dictionary-pair-names {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}
.dictionary-page .dictionary-pair-names strong {
  font-size: 17px;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-pair-names small {
  display: block;
  color: #64705e;
  margin-top: 6px;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-pair-arrow {
  color: #73836a;
  font-size: 20px;
}
.dictionary-page .dictionary-suggestion-reasons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  font-size: 13px;
  color: #53614d;
}
.dictionary-page .dictionary-comparison-reasons {
  border: 1px solid #e1d9c5;
  background: #fffdf6;
  padding: 16px;
  border-radius: 9px;
  margin-bottom: 20px;
  overflow-wrap: anywhere;
  font-size: 13px;
  line-height: 1.8;
}
.dictionary-page .dictionary-comparison-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  margin: 20px 0;
}
.dictionary-page .dictionary-comparison-side {
  padding: 18px;
  border: 1px solid #dce2d8;
  border-radius: 9px;
  min-width: 0;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-comparison-side h3 {
  font-size: 20px;
  line-height: 1.7;
}
.dictionary-page .dictionary-comparison-side .dictionary-preserved-description {
  font-size: 13px;
  line-height: 1.8;
}
.dictionary-page .dictionary-comparison-side .dictionary-source {
  padding: 12px;
}
.dictionary-page .dictionary-comparison-side details p {
  font-size: 13px;
  line-height: 1.8;
}
.dictionary-page .dictionary-comparison-side .e-actions {
  gap: 8px;
}
.dictionary-page .dictionary-matching-note {
  padding-top: 16px;
  border-top: 1px solid #e3e8de;
  margin-top: 24px;
}
@media (max-width: 900px) {
  .dictionary-page .dictionary-comparison-columns {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 500px) {
  .dictionary-page .dictionary-suggestions {
    padding: 16px;
  }
  .dictionary-page .dictionary-suggestion-row {
    padding: 14px;
  }
  .dictionary-page .dictionary-pair-names {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  .dictionary-page .dictionary-pair-arrow {
    line-height: 1;
  }
  .dictionary-page .dictionary-suggestions__header .e-actions > * {
    flex: 1 1 150px;
  }
  .dictionary-page .dictionary-comparison-side {
    padding: 12px;
  }
}
.dictionary-page .dictionary-operations {
  margin: 0;
  padding: 0;
  border: 0;
}
.dictionary-page .dictionary-operation-context {
  display: grid;
  gap: 20px;
  margin-top: 16px;
}
.dictionary-page .dictionary-context-card {
  min-width: 0;
  padding: 18px;
  border: 1px solid #dce3d7;
  border-radius: 10px;
  background: #fafbf8;
  display: grid;
  gap: 12px;
}
.dictionary-page .dictionary-context-card h4 {
  margin: 0 0 2px;
  font-size: 16px;
  color: #293923;
}
.dictionary-page .dictionary-context-card > .e-button {
  justify-self: start;
  max-width: 100%;
  white-space: normal;
  text-align: left;
}
.dictionary-page .dictionary-context-label {
  font-weight: 600;
  font-size: 13px;
  color: #43543b;
}
.dictionary-page .dictionary-context-empty {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #63705c;
}
.dictionary-page .dictionary-context-card .e-muted {
  margin: 0;
}
.dictionary-page .dictionary-alias-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.dictionary-page .dictionary-alias-list li {
  max-width: 100%;
  border: 1px solid #dce3d7;
  border-radius: 5px;
  padding: 4px 8px;
  background: white;
  overflow-wrap: anywhere;
  font-size: 13px;
}
.dictionary-page .dictionary-context-list {
  display: grid;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0;
}
.dictionary-page .dictionary-context-list li {
  display: grid;
  gap: 5px;
  min-width: 0;
  padding: 12px;
  border-radius: 6px;
  background: white;
  border: 1px solid #e3e8de;
  overflow-wrap: anywhere;
}
.dictionary-page .dictionary-context-list span, .dictionary-page .dictionary-context-list small {
  font-size: 12px;
  line-height: 1.6;
  color: #63705c;
}
.dictionary-page .dictionary-context-list .e-text-button {
  justify-self: start;
  text-align: left;
}
.dictionary-page .dictionary-suggestions {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
@media (max-width: 1279px) {
  .dictionary-page.is-detail-view .dictionary-searchbar, .dictionary-page.is-detail-view .dictionary-context:not(.has-important-status) {
    display: none;
  }
  .dictionary-page .dictionary-detail__header {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: 6px 12px;
  }
  .dictionary-page .dictionary-detail__header > .dictionary-mobile-back {
    grid-column: 1;
    grid-row: 1;
    margin: 0;
  }
  .dictionary-page .dictionary-detail__identity {
    display: contents;
  }
  .dictionary-page .dictionary-detail__identity > h2 {
    grid-column: 2;
    grid-row: 1;
  }
  .dictionary-page .dictionary-detail__summary {
    grid-column: 1/-1;
    margin-top: 0;
  }
  .dictionary-page .dictionary-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .dictionary-page .dictionary-workspace:not(.has-detail) .dictionary-detail {
    display: none;
  }
  .dictionary-page .dictionary-workspace.has-detail .dictionary-list {
    display: none;
  }
  .dictionary-page .dictionary-mobile-back {
    display: inline-flex;
    align-items: center;
    min-height: 36px;
    padding: 4px 0;
    margin-bottom: 6px;
    font-size: 13px;
  }
}
@media (max-width: 1000px) {
  .dictionary-page .dictionary-page-actions .e-button {
    min-height: 44px;
  }
}
@media (max-width: 700px) {
  .dictionary-page.is-detail-view .dictionary-searchbar, .dictionary-page.is-detail-view .dictionary-context:not(.has-important-status) {
    display: none;
  }
  .dictionary-page .creation-heading > p {
    display: none;
  }
  .dictionary-page .dictionary-stats {
    font-size: 12px;
    gap: 2px 10px;
  }
  .dictionary-page .dictionary-stats strong {
    font-size: 12px;
  }
  .dictionary-page .dictionary-stats > span:last-child {
    display: none;
  }
  .dictionary-page .dictionary-header-actions {
    gap: 6px;
  }
  .dictionary-page .dictionary-header-actions .e-button {
    padding-inline: 10px;
  }
  .dictionary-page .creation-main {
    gap: 8px;
  }
  .dictionary-page .dictionary-searchbar {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 10px;
    gap: 8px;
  }
  .dictionary-page .dictionary-searchbar__query {
    grid-column: 1/3;
  }
  .dictionary-page .dictionary-searchbar__reset {
    grid-column: 3;
    grid-row: 1;
  }
  .dictionary-page .dictionary-context {
    gap: 2px;
  }
  .dictionary-page .dictionary-sync {
    font-size: 12px;
    gap: 4px 8px;
  }
  .dictionary-page .dictionary-list__header {
    padding: 10px 12px;
  }
  .dictionary-page .dictionary-list__header h2 {
    font-size: 14px;
  }
  .dictionary-page .dictionary-range {
    font-size: 12px;
  }
  .dictionary-page .dictionary-column-head {
    display: none;
  }
  .dictionary-page .dictionary-row {
    grid-template-columns: minmax(0, 1fr) 66px 68px;
    grid-template-areas: "name type state" "name documents occurrences";
    gap: 4px 8px;
    min-height: 68px;
    padding: 10px;
  }
  .dictionary-page .dictionary-row__name {
    grid-area: name;
  }
  .dictionary-page .dictionary-row > .e-badge {
    grid-area: type;
  }
  .dictionary-page .dictionary-row > .dictionary-state {
    grid-area: state;
  }
  .dictionary-page .dictionary-count--documents {
    grid-area: documents;
  }
  .dictionary-page .dictionary-count--occurrences {
    grid-area: occurrences;
  }
  .dictionary-page .dictionary-count {
    text-align: left;
    font-size: 12px;
    white-space: nowrap;
  }
  .dictionary-page .dictionary-count__label {
    display: inline;
    margin-right: 4px;
    color: #64705e;
    font-size: 12px;
  }
  .dictionary-page .dictionary-list-pagination {
    justify-content: center;
    padding: 8px;
    gap: 6px;
  }
  .dictionary-page .dictionary-page-actions {
    justify-content: center;
    flex: 1 1 100%;
  }
  .dictionary-page .dictionary-page-actions .e-button {
    min-width: 44px;
    min-height: 44px;
  }
  .dictionary-page .dictionary-page-jump input {
    width: 100px;
    min-height: 44px;
  }
  .dictionary-page .dictionary-page-jump .e-button {
    min-height: 44px;
  }
  .dictionary-page .dictionary-detail__header {
    padding: 10px 14px;
  }
  .dictionary-page .dictionary-detail__header h2 {
    font-size: 20px;
    line-height: 26px;
  }
  .dictionary-page .dictionary-detail__summary {
    font-size: 12px;
    gap: 4px 8px;
    margin-top: 4px;
  }
  .dictionary-page .dictionary-detail-body {
    padding: 12px 14px;
  }
  .dictionary-page .dictionary-edit__row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 10px;
  }
  .dictionary-page .dictionary-edit__row:first-child > .ro-field:first-child {
    grid-column: 1/-1;
  }
  .dictionary-page .dictionary-edit__row:first-child > .ro-field:last-child {
    grid-column: 1/-1;
  }
  .dictionary-page .dictionary-tabs {
    margin-inline: 12px;
  }
  .dictionary-page .dictionary-tabs button {
    font-size: 13px;
  }
  .dictionary-page .dictionary-save {
    padding: 10px;
    gap: 6px;
  }
  .dictionary-page .dictionary-save > span {
    font-size: 12px;
  }
  .dictionary-page .dictionary-save .e-button {
    padding-inline: 10px;
  }
  .dictionary-page .dictionary-source {
    padding: 12px;
  }
  .dictionary-page .dictionary-source .e-actions > * {
    flex: 1 1 130px;
    text-align: center;
  }
  .dictionary-page .dictionary-sources .dictionary-sources__heading {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
  .dictionary-page .dictionary-sources .dictionary-sources__tools {
    flex: 1;
    justify-content: space-between;
    gap: 8px;
  }
  .dictionary-page .dictionary-sources .dictionary-source-main-actions {
    justify-content: space-between;
  }
}
@media (max-width: 380px) {
  .dictionary-page .dictionary-searchbar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dictionary-page .dictionary-searchbar__query {
    grid-column: 1/-1;
  }
  .dictionary-page .dictionary-searchbar__reset {
    grid-column: 2;
    grid-row: 3;
  }
}`],
})
export class PageEntityDictionaryComponent implements OnInit, OnDestroy {
    public rows: any[] = [];
    public types: string[] = [];
    public states = [{id:'draft',label:'초안'},{id:'editing',label:'정리 중'},{id:'confirmed',label:'확정'},{id:'archived',label:'보관'}];
    public stats: any = {entries:0,confirmed:0,occurrences:0};
    public statsLoaded = false;
    public keyword = ''; public scope = 'entry'; public type = ''; public state = ''; public page = 1; public pages = 1; public total = 0;
    public loading = true; public detailLoading = false; public busy = false; public showDetail = false;
    public limit = 20; public pageInput: number | string = 1; public pageError = ''; public detailRetry = '';
    public detailTab = 'basic';
    public sourceSelectionMode = false;
    public sourceInfo: {[key: string]: boolean} = Object.create(null);
    private tabScroll: {[key: string]: number} = {};
    public listError = ''; public error = ''; public message = ''; public data: any = null; public job: any = null;
    public form: any = null; public aliasesText = ''; public preview: any = null; public previewKey = ''; public previewLoading = '';
    public operation = ''; public operationError = ''; public candidateQuery = ''; public candidates: any[] = [];
    public operationContext: any = null; public contextLoading = false; public contextError = '';
    private contextEpoch = 0;
    public candidatePage = 1; public candidatePages = 1; public candidateLoading = false;
    public donors: any[] = []; public mergePlan: any = null; public mergeForm: any = {};
    public selectedSources: any = {}; public splitForm: any = {}; public destination: any = null; public splitReferences: boolean[] = [];
    private candidateEpoch = 0; private operationEpoch = 0;
    public showSuggestions = false; public suggestions: any[] = []; public suggestionQuery = ''; public suggestionStatus = 'pending';
    public suggestionPage = 1; public suggestionPages = 1; public suggestionTotal = 0; public suggestionsLoading = false;
    public matching: any = null; public matchingNeedsRefresh = false; public matchingError = '';
    public comparison: any = null; public comparisonLoading = false; public comparisonPlan: any = null; public comparisonTarget = '';
    public comparisonConfirmed = false; public suggestionBusy = false; public comparisonEvidence: any = {}; public evidenceLoading = '';
    private suggestionEpoch = 0; private comparisonEpoch = 0; private comparisonPlanEpoch = 0;
    private original = ''; private timer: any; private searchTimer: any; private listEpoch = 0; private detailEpoch = 0; private sourceEpoch = 0; private previewEpoch = 0;
    private destroyed = false; private removeGuard = () => {};
    private unload = (e: BeforeUnloadEvent) => { if (this.dirty() || this.operation || this.selectedCount() || this.suggestionBusy) { e.preventDefault(); e.returnValue = ''; } };
    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute) { }

    async ngOnInit() {
        const config = this.route?.snapshot.routeConfig;
        if (config) {
            const previous = config.canDeactivate;
            const guard = () => this.discard(); config.canDeactivate = [...(previous || []),guard];
            this.removeGuard = () => { config.canDeactivate = config.canDeactivate?.filter(g => g !== guard); };
        }
        window.addEventListener('beforeunload',this.unload);
        const p = new URLSearchParams(location.search);
        this.keyword = p.get('q') || ''; this.type = p.get('type') || ''; this.state = p.get('state') || '';
        this.scope = p.get('scope') === 'source' ? 'source' : 'entry';
        this.detailTab = ['sources','advanced'].includes(p.get('tab') || '') ? p.get('tab')! : 'basic';
        const page = Number(p.get('page'));
        this.page = Number.isInteger(page) && page > 0 ? page : 1;
        await this.service.init(); if (this.destroyed) return;
        await this.loadList();
        if (!this.destroyed && p.get('entry')) await this.open(p.get('entry')!);
        if (!this.destroyed && p.get('view') === 'candidates') await this.toggleSuggestions(true);
        this.timer = window.setInterval(() => { if (this.syncing()) void this.pollJob(); if (this.showSuggestions && this.matchingRunning()) void this.pollMatching(); },2000);
    }
    ngOnDestroy() { this.destroyed = true; this.contextEpoch++; this.listEpoch++; this.detailEpoch++; this.candidateEpoch++; this.operationEpoch++; this.suggestionEpoch++; this.comparisonEpoch++; this.comparisonPlanEpoch++; clearTimeout(this.searchTimer); clearInterval(this.timer); this.removeGuard(); window.removeEventListener('beforeunload',this.unload); }
    private async request(op: string, params: any = {}, payload?: any) {
        const options: RequestInit = {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}};
        if (payload !== undefined) { options.method = 'POST'; options.headers = {...options.headers,'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'}; options.body = new URLSearchParams({payload:JSON.stringify(payload)}).toString(); }
        let response: Response;
        try { response = await fetch('/api/v1/entity-dictionary?'+new URLSearchParams({op,...params}),options); }
        catch { throw new Error('서버에 연결하지 못했습니다. 네트워크 연결을 확인한 뒤 다시 시도해주세요.'); }
        const body = await response.json().catch(() => null);
        const code = typeof body?.code === 'number' ? body.code : response.status;
        if (!response.ok || code >= 400) {
            const message = code === 401 ? '로그인이 필요합니다. 다시 로그인한 후 시도해주세요.' : code === 403 ? '사전을 관리할 권한이 없습니다.' : '사전 요청을 처리하지 못했습니다. 다시 시도해주세요.';
            throw new Error(body?.data?.message || body?.message || message);
        }
        const object = (value: any) => value !== null && typeof value === 'object' && !Array.isArray(value);
        const own = (value: any, key: string) => object(value) && Object.prototype.hasOwnProperty.call(value,key);
        let result = body;
        if (own(body,'code') || own(body,'data')) {
            result = body.data;
            if (own(result,'data')) result = result.data;
        }
        const entry = (value: any) => object(value) && typeof value.representative === 'string' && Array.isArray(value.aliases) && Array.isArray(value.custom_sources);
        const sources = (value: any) => object(value) && Array.isArray(value.sources) && Number.isInteger(value.source_page) && Number.isInteger(value.source_pages);
        const action = payload?.action || op || 'list';
        let valid = object(result);
        if (valid && action === 'list') valid = Array.isArray(result.entries) && object(result.stats) && Array.isArray(result.types) &&
            ['entries','confirmed','occurrences'].every(k => Number.isFinite(result.stats[k])) && ['total','page','pages'].every(k => Number.isFinite(result[k]));
        if (valid && ['detail','save','source_link','merge','split','suggestion_merge'].includes(action)) valid = entry(result.entry) && sources(result) && Array.isArray(result.history);
        if (valid && action === 'sources') valid = sources(result);
        if (valid && action === 'operation_context') valid = result.entry_id === params.entry && Number.isInteger(result.revision) && Array.isArray(result.aliases) &&
            ['merge','related'].every(k => object(result[k]) && Array.isArray(result[k].items) && ['total','page','pages'].every(n => Number.isInteger(result[k][n]))) &&
            typeof result.merge.checked === 'boolean' && typeof result.merge.needs_refresh === 'boolean' && object(result.pending) && Number.isInteger(result.pending.total) && Array.isArray(result.pending.items);
        if (valid && action === 'preview') valid = ['surface','before','after'].every(k => typeof result[k] === 'string');
        if (valid && action === 'merge_preview') valid = entry(result.target) && Array.isArray(result.sources) && object(result.revisions) && object(result.counts) && Array.isArray(result.aliases) && Array.isArray(result.custom_sources);
        if (valid && action === 'suggestions') valid = Array.isArray(result.suggestions) && ['total','page','pages'].every(k => Number.isFinite(result[k]));
        if (valid && action === 'suggestion_compare') valid = entry(result.left?.entry) && entry(result.right?.entry) && sources(result.left) && sources(result.right) && object(result.revisions);
        if (valid && ['job','sync','suggestion_job','suggestion_scan'].includes(action)) valid = own(result,'job') && (result.job === null || object(result.job));
        if (!valid) throw new Error('사전 데이터를 불러오지 못했습니다. 다시 시도해주세요.');
        return result;
    }
    private remember() {
        const p = new URLSearchParams();
        if (this.keyword) p.set('q',this.keyword); if (this.type) p.set('type',this.type); if (this.state) p.set('state',this.state);
        if (this.scope !== 'entry') p.set('scope',this.scope);
        if (this.page > 1) p.set('page',String(this.page)); if (this.form?.id) p.set('entry',this.form.id);
        if (this.showSuggestions) p.set('view','candidates');
        if (this.detailTab !== 'basic') p.set('tab',this.detailTab);
        history.replaceState(history.state,'','/entity-dictionary'+(p.size ? '?'+p : ''));
    }
    async loadList(showLoading = true) {
        clearTimeout(this.searchTimer);
        const epoch = ++this.listEpoch; if (showLoading) this.loading = true; this.listError = '';
        try {
            const d = await this.request('list',{q:this.keyword,type:this.type,state:this.state,page:this.page,scope:this.scope});
            if (this.destroyed || epoch !== this.listEpoch) return;
            this.rows = d.entries; this.stats = d.stats; this.types = d.types; this.total = d.total; this.page = d.page; this.pages = d.pages; this.job = d.sync_job;
            this.statsLoaded = true;
            this.limit = Number.isInteger(d.limit) && d.limit > 0 ? d.limit : 20;
            this.pageInput = this.page; this.pageError = '';
            this.remember();
        } catch (e: any) { if (!this.destroyed && epoch === this.listEpoch) this.listError = e.message; }
        finally { if (!this.destroyed && epoch === this.listEpoch) { this.loading = false; await this.service.render(); } }
    }
    search() { clearTimeout(this.searchTimer); this.page = 1; this.listEpoch++; this.loading = true; this.listError = ''; this.pageError = ''; this.searchTimer = window.setTimeout(() => void this.loadList(),300); }
    async filter() { this.page = 1; await this.loadList(); }
    async clear() { this.keyword = ''; this.scope = 'entry'; this.type = ''; this.state = ''; this.page = 1; await this.loadList(); }
    async setPage(page: number) {
        if (this.loading || this.listError || !Number.isInteger(page) || page < 1 || page > this.pages || page === this.page) return;
        this.page = page; await this.loadList();
        if (!this.destroyed && !this.listError) this.focus('dictionary-list-title');
    }
    async jumpPage() {
        const page = Number(this.pageInput);
        if (!Number.isInteger(page) || page < 1 || page > this.pages) {
            this.pageError = `1부터 ${this.pages.toLocaleString()} 사이의 페이지를 입력해주세요.`;
            await this.service.render(); document.getElementById('dictionary-page')?.focus(); return;
        }
        this.pageError = ''; await this.setPage(page);
    }
    rangeStart() { return this.total ? (this.page - 1) * this.limit + 1 : 0; }
    rangeEnd() { return Math.min(this.page * this.limit,this.total); }
    private focus(id: string, block: ScrollLogicalPosition = 'start') {
        const element = document.getElementById(id);
        const panel = ['dictionary-detail-title','dictionary-name'].includes(id) ? document.getElementById('dictionary-detail-panel') : null;
        element?.focus({preventScroll:true}); (panel || element)?.scrollIntoView({block});
    }
    async backToList() {
        this.showDetail = false; await this.service.render();
        const id = 'dictionary-row-' + this.form?.id;
        this.focus(document.getElementById(id) ? id : 'dictionary-list-title','nearest');
    }
    async setDetailTab(tab: string, focusTab = false) {
        if (!['basic','sources','advanced'].includes(tab)) return;
        const body = document.getElementById('dictionary-detail-body');
        if (body) this.tabScroll[this.detailTab] = body.scrollTop;
        this.detailTab = tab; this.remember(); await this.service.render();
        if (body) body.scrollTop = this.tabScroll[tab] || 0;
        if (focusTab) document.getElementById('dictionary-tab-'+tab)?.focus({preventScroll:true});
        if (tab === 'advanced' && !this.operationContext && !this.contextLoading) await this.loadOperationContext();
    }
    tabKey(event: KeyboardEvent, tab: string) {
        const tabs = ['basic','sources','advanced'], index = tabs.indexOf(tab);
        const next = event.key === 'ArrowRight' ? (index+1)%3 : event.key === 'ArrowLeft' ? (index+2)%3 : event.key === 'Home' ? 0 : event.key === 'End' ? 2 : -1;
        if (next < 0) return;
        event.preventDefault(); void this.setDetailTab(tabs[next],true);
    }
    syncLabel() { return this.syncing() ? '추출 결과 불러오는 중…' : '추출 결과 새로 불러오기'; }
    syncing() { return ['queued','running'].includes(this.job?.status); }
    stateLabel(state: string) { return this.states.find(s => s.id === state)?.label || state; }
    methodLabel(method: string) { return ({index:'기존 XML 태그',ner:'NER 추출',manual:'수동 추가'} as any)[method] || method; }
    private signature() { return JSON.stringify({form:this.form,aliases:this.aliasesText}); }
    dirty() { return !!this.form && this.signature() !== this.original; }
    private discard() { return !this.busy && !this.suggestionBusy && (!(this.dirty() || this.operation || this.selectedCount()) || window.confirm('저장하지 않은 사전 입력 또는 병합·분리 선택이 있습니다. 입력을 버리고 이동할까요?')); }
    private apply(d: any) {
        this.data = d; this.sourceEpoch++; this.previewEpoch++; const e = d.entry;
        this.contextEpoch++; this.operationContext = null; this.contextError = ''; this.contextLoading = false;
        this.tabScroll = {};
        this.resetOperation(); this.selectedSources = {}; this.sourceSelectionMode = false; this.sourceInfo = Object.create(null);
        this.form = {id:e.id,revision:e.revision,representative:e.representative,entity_type:e.entity_type,qualifier:e.qualifier || '',description:e.description,
            state:e.state,custom_sources:JSON.parse(JSON.stringify(e.custom_sources))};
        this.aliasesText = e.aliases.join('\n'); this.original = this.signature(); this.preview = null; this.previewKey = ''; this.showDetail = true;
        if (this.detailTab === 'advanced' && e.id && !d.merged_target) void this.loadOperationContext();
    }
    async open(id: string, force = false) {
        if (!force && this.form?.id === id && !this.detailRetry) { this.showDetail = true; await this.service.render(); this.focus('dictionary-detail-title'); return; }
        if (!this.discard()) return;
        const epoch = ++this.detailEpoch; this.detailLoading = true; this.showDetail = true; this.detailRetry = ''; this.error = ''; this.message = '';
        await this.service.render(); this.focus('dictionary-detail-panel');
        try {
            const d = await this.request('detail',{entry:id});
            if (this.destroyed || epoch !== this.detailEpoch) return;
            this.apply(d); this.remember();
        } catch (e: any) { if (!this.destroyed && epoch === this.detailEpoch) { this.error = e.message; this.detailRetry = id; } }
        finally { if (!this.destroyed && epoch === this.detailEpoch) { this.detailLoading = false; await this.service.render(); this.focus(this.detailRetry ? 'dictionary-detail-error' : 'dictionary-detail-title'); } }
    }
    async create() {
        if (!this.discard()) return; this.detailEpoch++; this.detailLoading = false; this.detailRetry = ''; this.error = ''; this.message = '';
        this.detailTab = 'basic';
        this.apply({entry:{id:null,revision:0,representative:'',entity_type:'이름',description:'',state:'draft',aliases:[],custom_sources:[],source_count:0,document_count:0},sources:[],source_total:0,source_page:1,source_pages:1,history:[]});
        this.remember(); await this.service.render(); this.focus('dictionary-name');
    }
    async save() {
        if (this.busy || this.syncing() || !this.form) return; this.busy = true; this.error = ''; this.message = '';
        const epoch = this.detailEpoch;
        try {
            const d = await this.request('',{},{action:'save',...this.form,aliases:this.aliasesText.split(/\r?\n/).filter(v => v.trim())});
            if (this.destroyed || epoch !== this.detailEpoch) return;
            this.apply(d); this.message = '사전 내용을 저장했습니다.'; this.remember(); await this.loadList(false);
        } catch (e: any) { if (!this.destroyed && epoch === this.detailEpoch) this.error = e.message; }
        finally { if (!this.destroyed) { this.busy = false; await this.service.render(); } }
    }
    addReference() { this.form.custom_sources.push({title:'',url:'',note:''}); }
    removeReference(index: number) { this.form.custom_sources.splice(index,1); }
    async sourcePage(page: number) {
        if (!this.form?.id || this.busy) return; const epoch = this.detailEpoch, sourceEpoch = ++this.sourceEpoch; this.previewEpoch++;
        this.error = ''; let loaded = false;
        try { const d = await this.request('sources',{entry:this.form.id,page}); if (!this.destroyed && epoch === this.detailEpoch && sourceEpoch === this.sourceEpoch) { Object.assign(this.data,d); this.preview = null; this.previewKey = ''; loaded = true; } }
        catch (e: any) { if (!this.destroyed && epoch === this.detailEpoch) this.error = e.message; }
        if (!this.destroyed) {
            await this.service.render();
            if (loaded) {
                const body = document.getElementById('dictionary-detail-body');
                if (body) body.scrollTop = 0;
                document.getElementById('dictionary-sources-title')?.focus({preventScroll:true});
            }
        }
    }
    async showPreview(source: any) {
        const epoch = this.detailEpoch, previewEpoch = ++this.previewEpoch; this.previewLoading = source.source_key; this.error = '';
        try {
            const p = await this.request('preview',{entry:this.form.id,source:source.source_key});
            if (!this.destroyed && epoch === this.detailEpoch && previewEpoch === this.previewEpoch) { this.preview = p; this.previewKey = source.source_key; }
        } catch (e: any) { if (!this.destroyed && epoch === this.detailEpoch) this.error = e.message; }
        finally { if (!this.destroyed && epoch === this.detailEpoch) { this.previewLoading = ''; await this.service.render(); } }
    }
    async toggleSource(source: any, confirmPending = false) {
        if (this.busy || this.dirty() || this.syncing()) return; this.busy = true; this.error = '';
        try {
            const d = await this.request('',{},{action:'source_link',entry_id:this.form.id,source_key:source.source_key,included:confirmPending || !source.included,revision:this.form.revision});
            if (this.destroyed) return; this.apply(d); this.message = '사전의 출처 연결을 변경했습니다.'; await this.loadList(false);
        } catch (e: any) { if (!this.destroyed) this.error = e.message; }
        finally { if (!this.destroyed) { this.busy = false; await this.service.render(); } }
    }
    historyLabel(action: string) { return ({source_link:'출처 연결 변경',create:'항목 생성',edit:'사전 내용 수정',merge:'항목 병합',merged_into:'다른 항목으로 병합',split:'출처 분리',split_received:'분리된 출처 연결'} as any)[action] || action; }
    selectedCount() { return Object.keys(this.selectedSources).length; }
    selectedList(): any[] { return Object.values(this.selectedSources); }
    sourceSelecting() { return this.sourceSelectionMode || this.operation === 'split' || this.selectedCount() > 0; }
    toggleSourceSelection() {
        if (this.busy || this.syncing() || this.dirty() || this.operation) return;
        if (this.sourceSelecting()) { this.selectedSources = {}; this.sourceSelectionMode = false; }
        else this.sourceSelectionMode = true;
        void this.service.render();
    }
    sourceExcerpt(text: string, side: 'before' | 'after') {
        const chars = Array.from(text || ''), limit = side === 'before' ? 32 : 52;
        if (chars.length <= limit) return text || '';
        return side === 'before' ? '…' + chars.slice(-limit).join('') : chars.slice(0,limit).join('') + '…';
    }
    toggleSourceInfo(key: string) { this.sourceInfo[key] = !this.sourceInfo[key]; void this.service.render(); }
    selectSource(source: any, checked: boolean) {
        if (this.busy) return;
        if (checked && this.selectedCount() >= 5000) { this.error = '출처는 한 번에 5,000회까지 선택할 수 있습니다.'; void this.service.render(); return; }
        if (checked) this.selectedSources[source.source_key] = source; else delete this.selectedSources[source.source_key];
        void this.service.render();
    }
    selectSourcePage() { for (const s of this.data.sources) if (!this.selectedSources[s.source_key]) this.selectSource(s,true); }
    clearSelection() { this.selectedSources = {}; void this.service.render(); }
    private resetOperation() {
        this.operation = ''; this.operationError = ''; this.candidates = []; this.donors = []; this.destination = null;
        this.mergePlan = null; this.candidateQuery = ''; this.candidateLoading = false; this.candidateEpoch++; this.operationEpoch++;
    }
    cancelOperation() { if (!this.busy) { this.resetOperation(); void this.service.render(); } }
    async loadOperationContext(mergePage = 1, relatedPage = 1) {
        if (!this.form?.id || this.data?.merged_target || this.detailLoading && this.detailRetry) return;
        const epoch = ++this.contextEpoch, id = this.form.id, revision = this.form.revision;
        this.contextLoading = true; this.contextError = ''; await this.service.render();
        try {
            const d = await this.request('operation_context',{entry:id,merge_page:mergePage,related_page:relatedPage});
            if (this.destroyed || epoch !== this.contextEpoch || this.form?.id !== id) return;
            if (d.revision !== revision) throw new Error('항목이 변경됐습니다. 최신 항목을 불러온 뒤 다시 확인해주세요.');
            this.operationContext = d;
        } catch (e: any) { if (!this.destroyed && epoch === this.contextEpoch) this.contextError = e.message; }
        finally { if (!this.destroyed && epoch === this.contextEpoch) { this.contextLoading = false; await this.service.render(); } }
    }
    async showPendingSources() {
        const id = this.form?.id;
        await this.setDetailTab('sources');
        if (!this.destroyed && this.form?.id === id) await this.sourcePage(1);
    }
    async beginOperation(kind: string, candidate?: any) {
        if (this.busy || this.syncing() || this.dirty() || !this.form?.id || this.data.entry.merged_into) return;
        this.resetOperation(); this.operation = kind; this.candidateQuery = this.form.representative;
        if (kind === 'split') {
            this.splitForm = {mode:'new',representative:this.form.representative,entity_type:this.form.entity_type,qualifier:'',
                remaining_qualifier:this.form.qualifier,description:this.form.description,aliases:this.aliasesText};
            this.splitReferences = this.form.custom_sources.map(() => true);
            if (candidate) { this.splitForm.mode = 'existing'; this.destination = candidate; }
        }
        if (kind === 'merge' && candidate) this.donors = [candidate];
        if (candidate || kind === 'split') { await this.service.render(); return; }
        await this.findCandidates(1);
    }
    async findCandidates(page = 1) {
        const epoch = ++this.candidateEpoch; this.candidateLoading = true; this.operationError = '';
        try {
            const d = await this.request('list',{q:this.candidateQuery,page});
            if (this.destroyed || epoch !== this.candidateEpoch) return;
            this.candidates = d.entries.filter((e: any) => e.id !== this.form.id);
            this.candidatePage = d.page; this.candidatePages = d.pages;
        } catch (e: any) { if (!this.destroyed && epoch === this.candidateEpoch) this.operationError = e.message; }
        finally { if (!this.destroyed && epoch === this.candidateEpoch) { this.candidateLoading = false; await this.service.render(); } }
    }
    donorSelected(id: string) { return this.donors.some(e => e.id === id); }
    chooseCandidate(entry: any) {
        if (this.busy) return;
        this.operationError = '';
        if (this.operation === 'merge') {
            this.mergePlan = null; this.operationEpoch++;
            if (this.donorSelected(entry.id)) this.donors = this.donors.filter(e => e.id !== entry.id);
            else if (this.donors.length < 20) this.donors.push(entry);
            else this.operationError = '한 번에 20개 항목까지 합칠 수 있습니다.';
        } else this.destination = entry;
        void this.service.render();
    }
    async previewMerge() {
        if (this.busy || !this.donors.length || this.dirty() || this.syncing()) return;
        this.busy = true; this.operationError = ''; const epoch = ++this.operationEpoch;
        try {
            const plan = await this.request('',{},{action:'merge_preview',target_id:this.form.id,source_ids:this.donors.map(e => e.id)});
            if (this.destroyed || epoch !== this.operationEpoch) return;
            this.mergePlan = plan; this.mergeForm = {representative:plan.target.representative,entity_type:plan.target.entity_type,qualifier:plan.target.qualifier};
        } catch (e: any) { if (!this.destroyed && epoch === this.operationEpoch) this.operationError = e.message; }
        finally { if (!this.destroyed) { this.busy = false; await this.service.render(); } }
    }
    async applyMerge() {
        if (this.busy || !this.mergePlan || this.dirty() || this.syncing()) return;
        this.busy = true; this.operationError = '';
        try {
            const d = await this.request('',{},{action:'merge',target_id:this.form.id,source_ids:this.mergePlan.sources.map((e: any) => e.id),revisions:this.mergePlan.revisions,...this.mergeForm});
            if (this.destroyed) return;
            const moved = d.operation.moved_sources; this.apply(d); this.message = `항목을 합쳤습니다. 옮긴 출처 ${moved.toLocaleString()}회의 원문 정보를 보존했습니다.`;
            this.remember(); await this.loadList(false);
        } catch (e: any) { if (!this.destroyed) { this.operationError = e.message; this.mergePlan = null; } }
        finally { if (!this.destroyed) { this.busy = false; await this.service.render(); } }
    }
    async applySplit() {
        if (this.busy || !this.selectedCount() || this.dirty() || this.syncing() || (this.splitForm.mode === 'existing' && !this.destination)) return;
        this.busy = true; this.operationError = ''; const f = this.splitForm, existing = f.mode === 'existing';
        try {
            const d = await this.request('',{},{action:'split',entry_id:this.form.id,revision:this.form.revision,source_keys:Object.keys(this.selectedSources),
                destination_id:existing ? this.destination.id : null,destination_revision:existing ? this.destination.revision : null,
                new_entry:existing ? null : {representative:f.representative,entity_type:f.entity_type,qualifier:f.qualifier,description:f.description,aliases:f.aliases.split(/\r?\n/).filter((v: string) => v.trim())},
                remaining_qualifier:f.remaining_qualifier,custom_source_indexes:this.splitReferences.flatMap((yes,i) => yes ? [i] : [])});
            if (this.destroyed) return;
            const moved = d.operation.moved_sources; this.apply(d); this.message = `선택한 출처 ${moved.toLocaleString()}회를 별도 항목으로 옮겼습니다. 원문과 기존 항목의 추가 출처는 보존했습니다.`;
            this.remember(); await this.loadList(false);
        } catch (e: any) { if (!this.destroyed) this.operationError = e.message; }
        finally { if (!this.destroyed) { this.busy = false; await this.service.render(); } }
    }
    async startSync() {
        if (this.busy || this.suggestionBusy || this.syncing()) return; this.error = '';
        try { const d = await this.request('',{},{action:'sync'}); if (!this.destroyed) { this.job = d.job; this.message = '추출 결과를 불러옵니다. 작성 중인 입력은 유지됩니다.'; } }
        catch (e: any) { if (!this.destroyed) this.error = e.message; }
        if (!this.destroyed) await this.service.render();
    }
    matchingRunning() { return ['queued','running'].includes(this.matching?.status); }
    async toggleSuggestions(show: boolean) {
        if (this.busy || this.suggestionBusy || this.dirty() || this.operation) return;
        this.showSuggestions = show; this.remember();
        if (show) await this.loadSuggestions(1,true); else { this.comparisonEpoch++; this.comparisonPlanEpoch++; this.comparison = null; }
        await this.service.render();
    }
    async loadSuggestions(page = 1, auto = false) {
        const epoch = ++this.suggestionEpoch; this.suggestionsLoading = true; this.matchingError = '';
        try {
            const d = await this.request('suggestions',{q:this.suggestionQuery,status:this.suggestionStatus,page});
            if (this.destroyed || epoch !== this.suggestionEpoch) return;
            this.suggestions = d.suggestions; this.suggestionPage = d.page; this.suggestionPages = d.pages; this.suggestionTotal = d.total;
            this.matching = d.job; this.matchingNeedsRefresh = d.needs_refresh;
            if (auto && d.needs_refresh && !this.matchingRunning() && !this.syncing()) await this.refreshSuggestions();
        } catch (e: any) { if (!this.destroyed && epoch === this.suggestionEpoch) this.matchingError = e.message; }
        finally { if (!this.destroyed && epoch === this.suggestionEpoch) { this.suggestionsLoading = false; await this.service.render(); } }
    }
    async refreshSuggestions() {
        if (this.suggestionBusy || this.matchingRunning() || this.syncing()) return;
        this.matchingError = '';
        try {
            const d = await this.request('',{},{action:'suggestion_scan'});
            if (!this.destroyed) { this.matching = d.job; this.matchingNeedsRefresh = d.needs_refresh; if (d.job?.status === 'completed') await this.loadSuggestions(this.suggestionPage); }
        }
        catch (e: any) { if (!this.destroyed) this.matchingError = e.message; }
        if (!this.destroyed) await this.service.render();
    }
    async pollMatching() {
        try {
            const d = await this.request('suggestion_job'); if (this.destroyed) return;
            const running = this.matchingRunning(); this.matching = d.job; this.matchingNeedsRefresh = d.needs_refresh;
            if (running && !this.matchingRunning()) await this.loadSuggestions(this.suggestionPage);
        } catch (e: any) { if (!this.destroyed) this.matchingError = e.message; }
        if (!this.destroyed) await this.service.render();
    }
    async compareSuggestion(id: string, leftPage = 1, rightPage = 1) {
        if (this.suggestionBusy) return;
        const epoch = ++this.comparisonEpoch; this.comparisonLoading = true; this.comparisonConfirmed = false;
        this.comparisonPlan = null; this.comparisonPlanEpoch++; this.matchingError = ''; this.comparisonEvidence = {};
        try {
            const d = await this.request('suggestion_compare',{candidate:id,left_page:leftPage,right_page:rightPage});
            if (this.destroyed || epoch !== this.comparisonEpoch) return;
            this.comparison = d;
            if (![d.left.entry.id,d.right.entry.id].includes(this.comparisonTarget)) this.comparisonTarget = d.left.entry.source_count >= d.right.entry.source_count ? d.left.entry.id : d.right.entry.id;
            await this.loadComparisonPlan();
        } catch (e: any) { if (!this.destroyed && epoch === this.comparisonEpoch) this.matchingError = e.message; }
        finally { if (!this.destroyed && epoch === this.comparisonEpoch) { this.comparisonLoading = false; await this.service.render(); } }
    }
    async loadComparisonPlan() {
        if (!this.comparison) return;
        const epoch = ++this.comparisonPlanEpoch; this.comparisonConfirmed = false; this.comparisonPlan = null;
        try {
            const other = this.comparison.left.entry.id === this.comparisonTarget ? this.comparison.right.entry.id : this.comparison.left.entry.id;
            const d = await this.request('',{},{action:'merge_preview',target_id:this.comparisonTarget,source_ids:[other]});
            if (this.destroyed || epoch !== this.comparisonPlanEpoch) return;
            if (Object.keys(d.revisions).some(id => d.revisions[id] !== this.comparison.revisions[id])) throw new Error('비교 중 항목이 변경됐습니다. 출처 비교를 다시 열어주세요.');
            this.comparisonPlan = d;
        } catch (e: any) { if (!this.destroyed && epoch === this.comparisonPlanEpoch) this.matchingError = e.message; }
        if (!this.destroyed) await this.service.render();
    }
    closeComparison() {
        if (this.suggestionBusy) return;
        this.comparisonEpoch++; this.comparisonPlanEpoch++; this.comparison = null; this.comparisonPlan = null; this.comparisonConfirmed = false;
        this.comparisonLoading = false; void this.service.render();
    }
    async compareSourcePage(side: string, page: number) {
        if (!this.comparison) return;
        await this.compareSuggestion(this.comparison.id,side === 'left' ? page : this.comparison.left.source_page,side === 'right' ? page : this.comparison.right.source_page);
    }
    async showComparisonEvidence(entry: string, source: string) {
        const epoch = this.comparisonEpoch; this.evidenceLoading = source; this.matchingError = '';
        try {
            const d = await this.request('preview',{entry,source});
            if (!this.destroyed && epoch === this.comparisonEpoch) this.comparisonEvidence[source] = d;
        } catch (e: any) { if (!this.destroyed && epoch === this.comparisonEpoch) this.matchingError = e.message; }
        finally { if (!this.destroyed && epoch === this.comparisonEpoch) { this.evidenceLoading = ''; await this.service.render(); } }
    }
    async dismissSuggestion() {
        if (this.suggestionBusy || !this.comparison || this.comparisonLoading) return;
        this.suggestionBusy = true; this.matchingError = '';
        try {
            await this.request('',{},{action:'suggestion_dismiss',suggestion_id:this.comparison.id,revisions:this.comparison.revisions});
            if (this.destroyed) return;
            this.comparison = null; this.message = '다른 개체로 제외했습니다. 이 후보 쌍은 다시 추천하지 않습니다.'; await this.loadSuggestions(this.suggestionPage);
        } catch (e: any) { if (!this.destroyed) this.matchingError = e.message; }
        finally { if (!this.destroyed) { this.suggestionBusy = false; await this.service.render(); } }
    }
    async mergeSuggestion() {
        if (this.suggestionBusy || !this.comparison || !this.comparisonPlan || !this.comparisonConfirmed || this.syncing()) return;
        this.suggestionBusy = true; this.matchingError = '';
        try {
            const p = this.comparisonPlan;
            const d = await this.request('',{},{action:'suggestion_merge',suggestion_id:this.comparison.id,confirmed:this.comparisonConfirmed,
                target_id:p.target.id,source_ids:p.sources.map((e: any) => e.id),revisions:p.revisions,
                representative:p.target.representative,entity_type:p.target.entity_type,qualifier:p.target.qualifier});
            if (this.destroyed) return;
            this.apply(d); this.comparison = null; this.comparisonPlan = null; this.comparisonConfirmed = false;
            this.message = '확인한 후보를 병합했습니다. 기존 표기·설명·출처와 변경 이력을 보존했습니다.';
            await this.loadList(false); await this.loadSuggestions(this.suggestionPage);
        } catch (e: any) { if (!this.destroyed) { this.matchingError = e.message; this.comparisonConfirmed = false; } }
        finally { if (!this.destroyed) { this.suggestionBusy = false; await this.service.render(); } }
    }
    async pollJob() {
        try {
            const d = await this.request('job'); if (this.destroyed) return;
            const wasRunning = this.syncing(); this.job = d.job;
            if (wasRunning && !this.syncing()) { await this.loadList(false); this.message = this.job?.status === 'completed' ? '추출 결과를 불러왔습니다. 사전에 작성한 내용은 보존됩니다.' : ''; }
        } catch { /* The visible job remains available for an explicit refresh. */ }
        if (!this.destroyed) await this.service.render();
    }
}

export default PageEntityDictionaryComponent;